import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  orderNumberLengths: (() => [8, 13, 23]) as unknown as number[],
  showLoginForm: true,
  showZipCodeInput: true
} satisfies RecursivePartial<PagesConfig['orderStatus']>
